import { useQuery } from '@tanstack/react-query';
import ESignApi from 'apis/eSginApis';

/**
 * 매장 목록 가져오기
 * @param {string| null} businessNumber
 * @param {bool} enabled
 */
export const useStoreList = (businessNumber, enabled = true) => {
  return useQuery({
    queryKey: ['storeList', businessNumber],
    queryFn: async () => {
      const data = await ESignApi.getStoreOfContract(businessNumber);
      return data;
    },
    enabled: enabled && !!businessNumber,
    staleTime: 1 * 60 * 1000, // 1분 신선 데이터
    cacheTime: 1 * 60 * 1000, // 1분 캐시 유지
    retry: false,
  });
};

/**
 * 모두사인 보안 링크 가져오기
 * @param {string} businessNumber
 * @param {string} signRedirectUrl
 * @param {bool} enabled
 */
export const useModusignLink = (businessNumber, signRedirectUrl, enabled = true) => {
  return useQuery({
    queryKey: ['modusignLink', businessNumber],
    queryFn: async () => {
      const response = await ESignApi.getModusignLink(businessNumber, signRedirectUrl);
      return response;
    },
    enabled: enabled && !!businessNumber,
    staleTime: 1 * 60 * 1000, // 1분 신선 데이터
    cacheTime: 1 * 60 * 1000, // 1분 캐시 유지
    retry: false,
  });
};

/**
 * 모두사인 문서 가져오기
 * @param {int} storeId
 * @param {string} status
 * @param {boolean} enabled
 */
export const useModusignDocument = (storeId, status, enabled = true) => {
  return useQuery({
    queryKey: ['modusignDocuments', storeId],
    queryFn: async () => {
      const documents = await ESignApi.getModusignDocument(storeId, status);
      return documents;
    },
    enabled: enabled && !!storeId,
    staleTime: 0 * 60 * 1000, // 0분 신선 데이터
    cacheTime: 0 * 60 * 1000, // 0분 캐시 유지
  });
};
